import { render, staticRenderFns } from "./PosCustomerAccount.vue?vue&type=template&id=86758e4a"
import script from "./PosCustomerAccount.vue?vue&type=script&lang=js"
export * from "./PosCustomerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports